/**
 * يفحص ما إذا كان localStorage يحتوي رمز جلسة Supabase صالحاً.
 *
 * نستخدمه قبل أيّ redirect لـ /auth من حارس مسار الأدمن، لتفادي
 * طرد المستخدم خلال نافذة سباق قصيرة (HMR، أو bootstrap كسول)
 * حيث `user=null` مؤقّتاً بينما الجلسة محفوظة فعلاً في القرص.
 */
export function hasLocalSupabaseSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (key.startsWith("sb-") && key.endsWith("-auth-token")) {
        const raw = localStorage.getItem(key);
        if (!raw) continue;
        // قيمة Supabase JSON تحوي access_token حين تكون صحيحة
        if (raw.includes("access_token")) return true;
      }
    }
  } catch {
    /* localStorage محظور */
  }
  return false;
}

/**
 * معاينة Lovable داخل المحرّر تعتمد على وسيط postMessage للجلسة. أثناء HMR أو
 * إعادة تشغيل Vite قد يتأخر الوسيط ثوانٍ قليلة ويُرجع getSession قيمة null
 * مؤقّتة رغم بقاء جلسة المحرّر صحيحة. لا يجوز اعتبار تلك النافذة logout فوراً.
 */
export function isBrokeredPreviewFrame(): boolean {
  if (typeof window === "undefined" || window.parent === window) return false;
  const host = window.location.hostname;
  return [
    "lovableproject.com",
    "lovableproject-dev.com",
    "lovable.app",
    "gpt-eng.com",
    "gptengineer.run",
  ].some((zone) => host === zone || host.endsWith(`.${zone}`));
}
